import { NavLink, Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { VscTriangleUp } from "react-icons/vsc";
import { useContext, useState } from "react";
import homeImg from "../assets/1stle-logo.png";
import { useAuth0 } from "@auth0/auth0-react";
import PermissionGuard from "./User/PermissionGuard";
import PermissionsMap from "./User/PermissionsMap";
import UserContext from "./User/UserContext";
import { NotificationBadge } from "@1stle/messenger-library";
const Nav = ({ hasUnsavedFormData, setHasUnsavedFormData }) => {
	const [menuOpen, setMenuOpen] = useState(false);
	const { logout, user } = useAuth0();
	const [showInjurySupport, setShowInjurySupport] = useState(false);
	const env = useContext(UserContext);

	const logOut = () => {
		fetch(env.api + "/logout", {
			method: "POST",
			headers: {
				Accept: "application/json",
				Authorization: "Bearer " + env.token,
			},
		}).then(() => {
			logout({ logoutParams: { returnTo: window.location.origin + "/login" } });
		});
	};

	const checkForUnsavedData = (e) => {
		if (typeof hasUnsavedFormData !== "undefined" && hasUnsavedFormData === true) {
			let confirmationResult = window.confirm("You have unsaved changes, are you sure you want to leave?");
			if (confirmationResult === true) {
				setHasUnsavedFormData(false);
			} else {
				e.preventDefault();
			}
		}
	};

	const checkUnsavedAndCloseMenu = (e) => {
		setMenuOpen(false);
		checkForUnsavedData(e);
	};

	if (!user) {
		return;
	}

	// Get user's odoo_id from auth0 claim
	const userClaim = user["https://claim.krummycapture/claim"];
	const odooId = userClaim?.odoo_id;
	const faviconHref = `${process.env.PUBLIC_URL || ""}/favicon.ico`;

	return (
		<nav>
			{showInjurySupport ? (
				<div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black/[.7] z-[200]">
					<div className="bg-white p-8 rounded-lg text-center mx-4">
						<p className="text-[40px] font-bold  mb-4 underline underline-offset-4">Injury Procedure</p>
						<p className="text-lg ">Read and execute every step carefully.</p>
						<div className="text-left">
							<div className="text-lg md:text-base">
								<ol className="list-decimal pl-4">
									<li className="mb-1 font-extrabold text-lg ">
										<span className="bg-yellow-200">For any life-threatening injuries - CALL 911 IMMEDIATELY.</span>
									</li>
									<li className="mb-1 font-extrabold text-lg">
										If the injury is not life-threatening, start making calls in this order. (The injury will need to be reported to all
										contacts below within 1 hour of the incident taking place.):
									</li>
									<ol className="list-[lower-alpha] pl-6 text-sm">
										<li className="font-extrabold">Call and notify our HR dept of the injury: 209-601-8771</li>
										<li className="font-extrabold">
											Call a Triage Nurse: 1-855-485-4176
											<span className=" font-bold text=sm">
												(your assigned nurse will be able to provide directions on the next steps to take.)
											</span>
										</li>
										<li className="font-extrabold">
											Call our Manager.
											<span className=" font-bold text-sm">(If your manager is not available call Don Silva: 209-896-7299)</span>
										</li>
										<li className="font-extrabold">Call Jarett Krum: 209-322-7012</li>
									</ol>
									<li className="mb-1 font-extrabold">
										Complete the Employee Incident Report<span className=" font-bold">( in the orange safety binder)</span> to the best of
										your ability and be sure to include as much detail as possible.
									</li>
									<li className="mb-1 font-extrabold">
										Email the folowing to our HR dept via email to{" "}
										<a href=" mailto:humanresources@1stle.com " className=" font-bold underline text-green-900 hover:text-green-500">
											humanresources@1stle.com
										</a>
										.
									</li>
									<ol className="list-[lower-alpha] pl-6 text-sm">
										<li className=" font-extrabold">Your completed Report from step3</li>
										<li className="font-extrabold">
											Provide the name and address of the medical center where your injuries will be assessed.
											<span className=" text-sm font-bold">
												( This will be determined during your phone call with your assigned Triage Nurse.)
											</span>
										</li>
									</ol>
								</ol>
								<div classname="space-y-4 mb-4">
									<p className=" font-bold space-y-4 mt-16 ">For all inquiries, please contact our Human Resources Department.</p>
									<p className=" font-bold ">Call/Text:209-601-8771</p>
									<p className="font-bold">Email: humanresources@1stle.com</p>
								</div>
							</div>
						</div>

						<button className="bg-gray-500 hover:bg-gray-600 p-3 text-white rounded-lg mt-3" onClick={() => setShowInjurySupport(false)}>
							Close
						</button>
					</div>
				</div>
			) : null}

			<div className="text-center bg-black text-white p-4 flex justify-between md:items-center">
				<div className="flex items-center gap-3">
					<NavLink to="/dashboard" onClick={checkForUnsavedData}>
						<img src={homeImg} alt="home" className="w-auto h-12" />
					</NavLink>
					{odooId && <NotificationBadge odooId={odooId} faviconHref={faviconHref} />}
				</div>
				<div className="hidden md:flex md:gap-3 md:items-center">
					<Link to="/app-download" onClick={checkForUnsavedData}>
						App Download
					</Link>
					<p className="cursor-pointer" onClick={(e) => setShowInjurySupport(true)}>
						Injury Support
					</p>
					<Link to="training" onClick={checkForUnsavedData}>
						Guides/SoPs
					</Link>
					<PermissionGuard permission={PermissionsMap.WORD_BANK_READ}>
						<Link to="/wordbank" onClick={checkForUnsavedData}>
							Word Bank
						</Link>
					</PermissionGuard>
					<Link to="/orders?page=1">Orders</Link>
					<PermissionGuard permission={PermissionsMap.TEMPLATES_READ}>
						<Link to="/templates?page=1&archived=0&query=&type=all&model=all&portfolio=all" onClick={checkForUnsavedData}>
							Templates
						</Link>
					</PermissionGuard>

					<PermissionGuard permission={PermissionsMap.VIEW_CLOCKING_NOTES}>
						<Link to="/clocking-notes" onClick={checkUnsavedAndCloseMenu}>
							Clocking Notes
						</Link>
					</PermissionGuard>

					{/* {(requestAccess || isAdmin) && !isPublicStorage ? (
						<Link to="/request-list" onClick={checkForUnsavedData}>
							Requests
						</Link>
					) : null} */}
					<Link to="/projects/search?query= &page=1&contract=&stage=&template=&model=all" onClick={checkForUnsavedData}>
						Projects
					</Link>
					<PermissionGuard permission={PermissionsMap.REPORTS_READ}>
						<Link to="/reports" onClick={checkForUnsavedData}>
							Reports
						</Link>
					</PermissionGuard>

					<p className="cursor-pointer" onClick={(e) => logOut(e)}>
						Log out
					</p>
				</div>
				<div className="flex flex-col items-end justify-center md:hidden">
					{menuOpen ? (
						<VscTriangleUp
							onClick={() => setMenuOpen((prev) => !prev)}
							className="text-4xl cursor-pointer border border-white rounded p-1 select-none"
						/>
					) : (
						<GiHamburgerMenu
							onClick={() => setMenuOpen((prev) => !prev)}
							className="text-4xl cursor-pointer border border-white rounded p-1 select-none"
						/>
					)}
				</div>
			</div>
			<div className={`bg-black text-white flex flex-col ${menuOpen ? "pr-4 pb-4" : " "} items-end justify-center md:hidden`}>
				{menuOpen ? (
					<div className="flex flex-col text-left gap-4">
						<Link to="/app-download" onClick={checkUnsavedAndCloseMenu}>
							App Download
						</Link>
						<p className="cursor-pointer" onClick={(e) => setShowInjurySupport(true)}>
							Injury Support
						</p>
						{/* <Link to="/training?path=/Commercial/PS%2027146%20-%20Baltimore" onClick={checkForUnsavedData}>Guides/SoPs</Link> for testing */}
						<Link to="/training" onClick={checkForUnsavedData}>
							Guides/SoPs
						</Link>
						<PermissionGuard permission={PermissionsMap.WORD_BANK_READ}>
							<Link to="/wordbank" onClick={checkUnsavedAndCloseMenu}>
								Word Bank
							</Link>
						</PermissionGuard>

						<Link to="/orders?page=1">Orders</Link>
						<PermissionGuard permission={PermissionsMap.TEMPLATES_READ}>
							<Link to="/templates?page=1&archived=0&query=&type=all&model=all&portfolio=all" onClick={checkUnsavedAndCloseMenu}>
								Templates
							</Link>
						</PermissionGuard>

						<PermissionGuard permission={PermissionsMap.VIEW_CLOCKING_NOTES}>
							<Link to="/clocking-notes" onClick={checkUnsavedAndCloseMenu}>
								Clocking
								<br />
								Notes
							</Link>
						</PermissionGuard>

						{/* {(requestAccess || isAdmin) && !isPublicStorage ? (
							<Link to="/request-list" onClick={checkUnsavedAndCloseMenu}>
								Requests
							</Link>
						) : null} */}
						<Link to="/projects/search?query= &page=1&contract=&stage=&template=&model=all" onClick={checkUnsavedAndCloseMenu}>
							Projects
						</Link>
						<PermissionGuard permission={PermissionsMap.REPORTS_READ}>
							<Link to="/reports" onClick={checkUnsavedAndCloseMenu}>
								Reports
							</Link>
						</PermissionGuard>

						<p className="cursor-pointer" onClick={(e) => logOut(e)}>
							Log out
						</p>
					</div>
				) : null}
			</div>
		</nav>
	);
};

export default Nav;
